<div class="icon-grid">
  @if (isTeacherOrEducatorStaffMember) {
    <div class="tile" matTooltip="Absences élèves">
      <a routerLink="admin/students/absencesByTeacher" data-cy="go-to-absences-by-teacher-page">
        <mat-icon inline>face</mat-icon>
      </a>
    </div>
  }
  @if (isTeacherStaffMember) {
    <div class="tile" matTooltip="Planning">
      <a routerLink="admin/planning" data-cy="go-to-planning-page">
        <mat-icon inline>calendar_today</mat-icon>
      </a>
    </div>
  }
  @if (isStaffMember) {
    <div class="tile" matTooltip="Remarques élèves">
      <a routerLink="admin/students/remarks" data-cy="go-to-remarks-page">
        <mat-icon inline>announcement</mat-icon>
      </a>
    </div>
  }
  @if (isTeacherOrEducatorStaffMember) {
    <div class="tile" matTooltip="Arrivées tardives">
      <a routerLink="admin/students/lateArrivals" data-cy="go-to-late-arrivals-page">
        <mat-icon inline>watch_later</mat-icon>
      </a>
    </div>
  }
  @if (isTeacherStaffMember) {
    <div class="tile" matTooltip="Exclusions">
      <a routerLink="admin/students/classExclusions" data-cy="go-to-class-exclusions-page">
        <mat-icon inline>exit_to_app</mat-icon>
      </a>
    </div>
  }
  @if (isStaffMember) {
    <div class="tile" matTooltip="Liste des élèves">
      <a routerLink="admin/students/list" data-cy="go-to-student-list-page">
        <mat-icon inline>groups</mat-icon>
      </a>
    </div>
  }
  @if (isTeacherStaffMember) {
    <div class="tile" matTooltip="Gestion des évaluations">
      <a routerLink="admin/score-book/evaluations" data-cy="go-to-evaluation-page">
        <mat-icon inline>menu_book</mat-icon>
      </a>
    </div>
  }
  @if (isStaffMember) {
    <div class="tile" matTooltip="Bulletins">
      <a routerLink="admin/school-report/consult" data-cy="go-to-report-consult-page">
        <mat-icon inline>description</mat-icon>
      </a>
    </div>
  }
</div>
